(function () {
  'use strict';

  var root = document.documentElement;
  var mobileQuery = window.matchMedia
    ? window.matchMedia('(max-width: 1024px)')
    : null;
  var observer = null;

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 1024;
  }

  function markFinalState(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope
      .querySelectorAll(
        [
          '[data-cd-animate]',
          '[data-cd-motion]',
          '[data-cd-motion-child]',
          '[data-cd-story-block-reveal]',
          '[data-cd-refills-block]',
          '[data-cd-pdp-statement-usp]',
          '[data-cd-cl-item]',
          '[data-cd-about-reveal]',
          '[data-cd-contact-reveal]',
          '[data-about-us-hero-reveal]',
          '[data-about-statement-reveal]'
        ].join(',')
      )
      .forEach(function (node) {
        node.classList.add('is-visible');
        node.setAttribute('data-cd-motion-state', 'done');
      });

    scope
      .querySelectorAll(
        [
          '[data-cd-dark-reveal]',
          '[data-cd-home-faq]',
          '[data-cd-home-specs]',
          '[data-cd-cl-hero]',
          '[data-cd-ci-banner]',
          '[data-cd-blog-hero]',
          '[data-about-us-hero]',
          '[data-about-statement]'
        ].join(',')
      )
      .forEach(function (node) {
        node.classList.add('is-inview', 'is-visible');
      });

    scope.querySelectorAll('[data-cd-dark-shop-reveal]').forEach(function (node) {
      node.classList.add('is-visible');
    });

    scope.querySelectorAll('[data-cd-contact-stage]').forEach(function (node) {
      node.classList.add('cd-contact-stage--ready', 'cd-contact-stage--visible');
    });

    scope.querySelectorAll('[data-cd-quality-materials]').forEach(function (node) {
      node.classList.add('cd-quality-materials--text-visible');
    });
  }

  function syncMode() {
    var mobile = isMobile();
    root.classList.toggle('cd-mobile-static', mobile);

    if (mobile) markFinalState(document);
  }

  syncMode();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMode, { once: true });
  } else {
    syncMode();
  }

  if (mobileQuery) {
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncMode);
    else if (mobileQuery.addListener) mobileQuery.addListener(syncMode);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (isMobile()) markFinalState(event.target || document);
  });

  if ('MutationObserver' in window) {
    observer = new MutationObserver(function (mutations) {
      if (!isMobile()) return;

      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) {
            markFinalState(node.matches ? node : document);
            if (node.matches && node.matches('[data-cd-animate], [data-cd-motion]')) {
              node.classList.add('is-visible');
              node.setAttribute('data-cd-motion-state', 'done');
            }
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
